import { FC } from 'react';
import styled from 'styled-components';
import { Text } from '../Text/Text';

const StyledSkipLink = styled.a`
  box-sizing: border-box;
  clip-path: inset(50%);
  clip: rect(0 0 0 0);
  display: block;
  height: 1px;
  left: 2rem;
  margin: 0;
  overflow: hidden;
  padding: 1rem 2rem;
  position: absolute;
  top: 2rem;
  width: 1px;
  z-index: 10;

  &:active,
  &:focus {
    clip-path: none;
    clip: auto;
    height: auto;
    margin: inherit;
    overflow: visible;
    width: auto;
  }

  &:focus {
    background-color: ${props => props.theme.vars.newColor.white};
  }
`;

export interface ISkipLinkProps {
  /** Text to show inside the SkipLink */
  text: string;
  /** Anchor location for the SkipLink to jump too. Default #content */
  anchor: string;
}

export const SkipLink: FC<ISkipLinkProps> = ({ anchor, text }) => {
  return (
    <StyledSkipLink data-testid="SkipLink" href={anchor}>
      <Text size={22} variation="link" weight="bold">
        {text}
      </Text>
    </StyledSkipLink>
  );
};

export default SkipLink;
